module.exports = __webpack_public_path__ + "static/media/hera.e066deca.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/hera.webp
// module id = 580
// module chunks = 0